/**
 * L'errore da mostrare sulla riga di un import CSV.
 *
 * **Perche' serve un modulo per due letture.** Il rifiuto di validazione non
 * arriva alla riga come una risposta: l'interceptor di `useApi` assorbe i 422 e
 * **risolve** col numero `422`, depositando il corpo nello store `errors`. Chi
 * importava un file si ritrovava una riga rossa e muta, perche' `res.message`
 * su un numero e' `undefined` — e il motivo del rifiuto e' proprio la cella che
 * deve correggere.
 *
 * Le due letture non ovvie stanno qui, dove un harness le puo' provare senza
 * montare un componente: dove sia la mappa dei campi dentro il corpo, e quale
 * codice ne ricavi la riga.
 */

/**
 * La mappa `{campo: [messaggio]}` come la trova chi legge lo store.
 *
 * Il corpo che l'api manda e' `{error, message, errors: {campo: [...]}}`, ma
 * **l'involucro lo scioglie l'interceptor**: nello store arriva gia' la mappa
 * dei campi. Prima non era cosi' e qui si scendeva di un livello con
 * `body.errors` — questa funzione era l'unico punto dell'applicazione che
 * leggeva la forma giusta, e tutti i form leggevano quella sbagliata.
 *
 * Un corpo di forma diversa — un 422 che non viene dalla validazione, o uno
 * store gia' azzerato — non e' un errore da propagare: vale come "nessun
 * campo", e la riga ricade sul messaggio generico.
 */
export const validationFieldsFrom = (body) =>
    body && typeof body === 'object' && !Array.isArray(body) ? body : {};

/**
 * Il codice d'errore della riga, che `ImportModalRow` mappa su una chiave i18n.
 *
 * La quantita' si nomina invece di ricadere sul generico: e' l'unica cella che
 * l'utente puo' correggere da sola, e «riga non importata» lo farebbe
 * ricontrollare tutte le colonne per una cifra. Gli altri campi non hanno
 * ancora un messaggio dedicato e restano generici, che e' comunque cio' che la
 * riga diceva prima.
 */
export const csvRowErrorCode = (response) =>
{
    if(response?.validation_errors?.quantity) return 'invalid_quantity';

    return response?.message ?? null;
};
